import { render } from "./PreviewModeBanner.vue?vue&type=template&id=6541380e&scoped=true"
import script from "./PreviewModeBanner.vue?vue&type=script&lang=js"
export * from "./PreviewModeBanner.vue?vue&type=script&lang=js"

import "./PreviewModeBanner.vue?vue&type=style&index=0&id=6541380e&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6541380e"]])

export default __exports__